module.exports = __webpack_public_path__ + "assets/webgl/card_052_EN_L0.60c0ba35.jpg";